/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date: Tue Jun 25 2024 14:48:42
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Link, Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { URL } from 'src/constants/links';

type Props = {
  open: boolean,
  onClose: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class ChangePlanFromReviewIO extends Component<ComposedProps> {
  render() {
    const { open, i18n } = this.props;

    return (
      <Modal
        open={open}
        onClose={this.handleClose}
        title={i18n.translate('AdminHTML.SubscriptionV4.BoltOn.upgradeModal.title')}
        primaryAction={{
          content: i18n.translate('AdminHTML.SubscriptionV4.BoltOn.upgradeModal.action'),
          destructive: true,
          onAction: () => window.open(URL['ReviewIOSubscriptionPage'], '_blank')
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleClose
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate('AdminHTML.SubscriptionV4.BoltOn.upgradeModal.content', {
                t: (
                  <Link external url={URL['ReviewIO']}>
                    {i18n.translate('AdminHTML.SubscriptionV4.BoltOn.upgradeModal.content_t')}
                  </Link>
                )
              })}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleClose = () => {
    this.props.onClose();
  };
}

export default withI18n()(ChangePlanFromReviewIO);
